import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'

import ObjetoAcaoService from '../../app/service/ObjetoAcaoService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'
import Progresso from '../../componentes/Progresso'

class ObjetosAcao extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      //Cadastro
      codigo: '',
      codigoPai: '',
      nome: '',
      empresa: null,
      objetos: [],
      subObjetosAcao: [],
      modalCadastro: false,
      modalAlterar: false,
      visivble: false,
      //Progresso
      classeDiv: 'hide',
      modalSubObjetos: false,
      modalCadastroSub: false,
    };

    this.objetoAcaoService = new ObjetoAcaoService();
    this.accept = this.accept.bind(this);
    this.acoes = this.acoes.bind(this);
    this.renderFooterCadastroObjetos = this.renderFooterCadastroObjetos.bind(this);
    this.renderFooterAlterarObjetos = this.renderFooterAlterarObjetos.bind(this);
    this.acoesSubObjetos = this.acoesSubObjetos.bind(this);
    this.acceptSubObjeto = this.acceptSubObjeto.bind(this);
    this.renderFooterCadastroSubObjetos = this.renderFooterCadastroSubObjetos.bind(this);
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  limparCampos = () => {
    this.setState({nome: ''});
  }

  accept() {
    this.excluirObjeto();
  }

  acceptSubObjeto() {
    this.excluirSubObjeto();
  }

  componentDidMount() {
    this.listarObjetosAcao();
  }

  listarObjetosAcao = async () => {
    this.setState({classeDiv: 'show'});
    const usuarioLogado = this.context.usuarioAutenticado
    await this.objetoAcaoService.listarObjetos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({objetos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Objetos de Ação', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({classeDiv: 'hide'});
  }

  listarSubObjetos = async (objeto) => {
    this.setState({codigoPai: objeto.codigo});
    this.objetoAcaoService.listarSubObjetos(objeto.codigo)
      .then(response => {
        this.setState({subObjetosAcao: response.data});
        this.abrirModalSubObjetos('modalSubObjetos');
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Sub-Objetos de Ação', detail:'Erro ao carregar Sub-Objetos de Ação', life: 4000});
      })
  }

  listarSubObjetosPosCadastro = async (codigo) => {
    this.objetoAcaoService.listarSubObjetos(codigo)
      .then(response => {
        this.setState({subObjetosAcao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Sub-Objetos de Ação', detail:'Erro ao carregar Sub-Objetos de Ação', life: 4000});
      })
  }

  abrirModalSubObjetos(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  cadastrarObjeto = async () => {
    this.setState({classeDiv: 'show'});
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Objetos de Ação', detail:'Informe o Objeto', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }
    const usuarioLogado = this.context.usuarioAutenticado
    await this.objetoAcaoService.cadastrarObjeto({
      nome: this.state.nome,
      objetoPai: 0,
      empresa: usuarioLogado.empresa
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Objetos de Ação', detail:'Objeto de Ação cadastrado com sucesso', life: 4000});
      this.listarObjetosAcao();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Objetos de Ação', detail:`${this.state.detail}`, life: 4000});
    })

    this.setState({classeDiv: 'hide'});
    this.fecharModalCadastro('modalCadastro');
  }

  cadastrarSubObjeto = async () => {
    this.setState({classeDiv: 'show'});
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Sub-Objetos de Ação', detail:'Informe o Sub-Objeto', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }
    const usuarioLogado = this.context.usuarioAutenticado
    await this.objetoAcaoService.cadastrarObjeto({
      nome: this.state.nome,
      objetoPai: this.state.codigoPai,
      empresa: usuarioLogado.empresa
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Sub-Objetos de Ação', detail:'Sub-Objeto de Ação cadastrado com sucesso', life: 4000});
      this.fecharModalCadastro('modalCadastroSub');
      this.listarSubObjetosPosCadastro(this.state.codigoPai);
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Sub-Objetos de Ação', detail:`${this.state.detail}`, life: 4000});
    })

    this.setState({classeDiv: 'hide'});
    this.fecharModalCadastro('modalCadastro');
  }

  async editar(objeto) {
    if(objeto != null) {
      this.setState({classeDiv: 'show'});
      this.setState({codigo: objeto.codigo});
      this.objetoAcaoService.consultarObjeto(objeto.codigo)
        .then(response => {
          this.setState({codigo: response.data.codigo});
          this.setState({nome: response.data.nome});
          this.abrirModaAlterar('modalAlterar');
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Objetos de Ação', detail:`${this.state.detail}`, life: 4000});
        });

        this.setState({classeDiv: 'hide'});
    }
  }

  alterarObjeto = async () => {
    this.setState({classeDiv: 'show'});
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Objetos de Ação', detail:'Informe o Objeto', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    const usuarioLogado = this.context.usuarioAutenticado
    await this.objetoAcaoService.alterarObjeto({
      codigo: this.state.codigo,
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Objetos de Ação', detail:'Objeto de Ação alterado com sucesso', life: 4000});
      this.listarObjetosAcao();
      if(this.state.codigoPai != '') {
        this.listarSubObjetosPosCadastro(this.state.codigoPai);
      }
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Objetos de Ação', detail:`${this.state.detail}`, life: 4000});
    });

    this.setState({classeDiv: 'hide'});
    this.fecharModalCadastro('modalAlterar');
  }

  renderFooterCadastroObjetos(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarObjeto}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  renderFooterCadastroSubObjetos(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarSubObjeto}/> 
             &nbsp;
            <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  renderFooterAlterarObjetos(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarObjeto}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.editar(rowData)}
                tooltip="Editar Objeto de Ação" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-sitemap" className="p-button-rounded p-button-text"
                onClick={() => this.listarSubObjetos(rowData)} 
                tooltip="Sub-Objetos de Ação" 
                tooltipOptions={{position: 'top'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Objeto de Ação" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  acoesSubObjetos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.editar(rowData)}
                tooltip="Editar Sub-Objeto de Ação" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusaoSubObjeto(rowData)} 
                tooltip="Excluir Sub-Objeto de Ação" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusao(objeto) {
    this.setState({codigo: objeto.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o Objeto de Ação?',
        header: 'Exclusão de Objeto de Ação',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  confirmaExclusaoSubObjeto(objeto) {
    this.setState({codigo: objeto.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o Sub-Objeto de Ação?',
        header: 'Exclusão de Sub-Objeto de Ação',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptSubObjeto,
        reject: this.reject
    });
  }

  excluirObjeto = async () => {
    this.setState({classeDiv: 'show'});
    this.objetoAcaoService.excluirObjeto(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Objetos de Ação', detail:'Objeto de Ação excluiído com sucesso', life: 4000});
        this.listarObjetosAcao();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Objetos de Ação', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({classeDiv: 'hide'});
  }

  excluirSubObjeto = async () => {
    this.setState({classeDiv: 'show'});
    this.objetoAcaoService.excluirObjeto(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Objetos de Ação', detail:'Objeto de Ação excluiído com sucesso', life: 4000});
        this.listarSubObjetosPosCadastro(this.state.codigoPai);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Objetos de Ação', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({classeDiv: 'hide'});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          {/**Cadastro de Objeto de Ação */}
          <Dialog header="Cadastro de Objeto de Ação"
                    visible={this.state.modalCadastro} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroObjetos('modalCadastro')} 
                    onHide={() => this.fecharModalCadastro('modalCadastro')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeStatus">Nome</label>
                        <InputText id="nomeStatus" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>

          {/**Cadastro de Sub-Objeto de Ação */}
          <Dialog header="Cadastro de Sub-Objeto de Ação"
                    visible={this.state.modalCadastroSub} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroSubObjetos('modalCadastroSub')} 
                    onHide={() => this.fecharModalCadastro('modalCadastroSub')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeStatus">Nome</label>
                        <InputText id="nomeStatus" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Objeto de Ação */}
          <Dialog header="Alterar Objeto de Ação"
                    visible={this.state.modalAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarObjetos('modalAlterar')} 
                    onHide={() => this.fecharModalCadastro('modalAlterar')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeStatusAlterar">Nome</label>
                        <InputText id="nomeStatusAlterar" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Sub-Objetos de Ação */}
          <Dialog header="Sub-Objetos de Ação"
                  visible={this.state.modalSubObjetos} 
                  style={{ width: '40vw' }} 
                  footer={
                    <div>
                        <Button label="Incluir" 
                                className="p-button-primary p-button-text" 
                                onClick={() => this.abrirModalCadastro('modalCadastroSub')}
                                ata-toggle="modal" 
                                data-target="#modal-default"/>
                        &nbsp;
                        <Button label="Fechar" 
                                className="p-button-secondary p-button-text"
                                onClick={() => this.fecharModalCadastro('modalSubObjetos')}/>
                      </div>
                  }
                  onHide={() => this.fecharModalCadastro('modalSubObjetos')}>

                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <DataTable value={this.state.subObjetosAcao}
                                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                  emptyMessage=" "
                                  currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={5}>
                        <Column field="nome" header="Sub-Objeto"></Column>
                        <Column body={this.acoesSubObjetos} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                      </DataTable>
                    </div>
                  </div>
                </div>
            </Dialog>
          <ConfirmDialog visible={this.state.visible} 
                         onHide={() => this.setState({ visible: false })} 
                         message="Are you sure you want to proceed?"
                         header="Confirmation"
                         icon="pi pi-exclamation-triangle" 
                         accept={() => this.excluirObjeto} 
                         reject={() => this.setState({visible: false})}/>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="far fa-object-ungroup"></i>
                        <span> Objetos de Ação</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalCadastro')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    <Progresso classeSecundaria={this.state.classeDiv}/>
                    </div>
                    <DataTable value={this.state.objetos}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                      <Column field="nome" header="Nome"></Column>
                      <Column key="codigo"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

ObjetosAcao.contextType = AuthContext;
export default withRouter (ObjetosAcao)
